import {
    DateTime
} from 'luxon'

/**
 * Luxon Documentation: https://moment.github.io/luxon/docs/manual/formatting.html
 */

let luxon = {
    methods: {
        /** FROM ISO */
        formatTimeSimple (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.TIME_SIMPLE)
        },

        formatTimeWithSeconds (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.TIME_WITH_SECONDS)
        },

        formatTime24Simple (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.TIME_24_SIMPLE)
        },

        formatTime24SimpleFromObject (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromObject(item).toLocaleString(DateTime.TIME_24_SIMPLE)
        },

        formatTime24WithSeconds (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.TIME_24_WITH_SECONDS)
        },

        formatDate (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.DATE_SHORT)
        },

        formatDateTime (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.DATETIME_SHORT)
        },

        formatDateTimeWithSeconds (item) {
            if (!item) {
                return ''
            }
            return DateTime.fromISO(item).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
        }
    }
}

export default luxon
